import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { HttpClientService } from 'src/app/service/http-client.service';
import { isSuccess, Response } from 'src/app/service/response';
import { UtilsService } from 'src/app/service/utils.service';
import { CommonCode } from './common-code';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  readonly timeOut = 10 * 60 * 1000;
  constructor(
    private httpClient: HttpClientService,
    private utils: UtilsService
  ) { }

  getCommonCode(commonCode: CommonCode) {
    const url = '/searchCommonCodeInfo';
    const data = commonCode;
    return this.httpClient.post(url, data, false);
  }

  updateCommonCode(updaterId: string, code: CommonCode, value: string) {
    const url = '/updateCommonCode';
    const data = {
      updaterId,
      commonCodeInfo: {
        gubunCd: code.gubunCd,
        lgCd: code.lgCd,
        midCd: code.midCd,
        smCd: code.smCd,
        ref01: value
      }
    };
    return this.httpClient.post(url, data, false);
  }

  downloadFile(url: string, data: any) {
    const httpOptions = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type':  'application/json;charset=UTF-8',
      })
    };
    return this.httpClient.post(url, data, true, httpOptions, this.timeOut);
  }

  // 응답 헤더까지 받아야 하는 다운로드용. HttpResponse 통째로 반환되므로 caller 가 res.body / res.headers 접근.
  downloadFileWithResponse(url: string, data: any) {
    const httpOptions = {
      responseType: 'blob',
      observe: 'response',
      headers: new HttpHeaders({
        'Content-Type':  'application/json;charset=UTF-8',
      })
    };
    return this.httpClient.post(url, data, true, httpOptions, this.timeOut);
  }
}
